'use client';

import { useEffect, useRef, useState } from 'react';
import dynamic from 'next/dynamic';
import useUserInteraction from '@/hooks/useUserInteraction';
import { needleAnalytic } from '@/services/needle';
import { Record as CookieRecord } from '@/lib/Storage/types';
import { cookieStorage } from '@/services/cookie';
const VideoDialog = dynamic(() => import('@/components/Dialogs/VideoDialog'), { ssr: false });

type CategoryBehaviourProps = {
  categoryName: string | undefined;
  cookieHeaders?: CookieRecord[];
};

const CategoryBehaviour = ({ categoryName, cookieHeaders }: CategoryBehaviourProps) => {
  const { isInteracted } = useUserInteraction();
  const [showModal, setShowModal] = useState<boolean>(false);
  const clickSrc = useRef<string>('');

  const setCategoryNeedle = async () => {
    try {
      await needleAnalytic.loadNeedleScript();
      await needleAnalytic.categoryNeedle(categoryName || '');
    } catch (err) {
      console.log('cant set category needle', err);
    }
  };

  const lazyLoadVideo = async () => {
    const clickElements = document.querySelectorAll('#Video');
    clickElements.forEach((element) => {
      const dataSrcValue = element.getAttribute('data-src');
      element.addEventListener('click', () => {
        clickSrc.current = dataSrcValue || '';
        setShowModal(true);
      });
    });

    return () => {
      clickElements.forEach((element) => {
        element.removeEventListener('click', () => {
          const dataSrcValue = element.getAttribute('data-src');
          element.addEventListener('click', () => {
            clickSrc.current = dataSrcValue || '';
            setShowModal(true);
          });
        });
      });
    };
  };

  const lazyLoadYoutubeVideo = async () => {
    const videos = document.querySelectorAll('#ytVideo');
    videos.forEach((childElement) => {
      const dataSrcValue = childElement.getAttribute('data-src');
      childElement.innerHTML = `
          <iframe
            src='https://www.youtube.com/embed/${dataSrcValue || ''}?&rel=0&amp;modestbranding=1'
            title="Pyramyd AIR Promo: Adventured in Recreation"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            loading="lazy"
          ></iframe>
        `;
    });
  };

  const setCookieHeaders = async () => {
    if (cookieHeaders) {
      cookieStorage.putMultiple(cookieHeaders);
    }
  };

  useEffect(() => {
    setCookieHeaders();
    lazyLoadVideo();
    setCategoryNeedle();
  }, []);

  useEffect(() => {
    if (isInteracted) {
      lazyLoadYoutubeVideo();
    }
  }, [isInteracted]);

  return showModal ? (
    <VideoDialog videoId={clickSrc.current} showDialog={showModal} onClose={() => setShowModal(false)} />
  ) : null;
};

export default CategoryBehaviour;
